import { render, staticRenderFns } from "./VuetifyCalendar.vue?vue&type=template&id=d5418bb2&scoped=true"
import script from "./VuetifyCalendar.vue?vue&type=script&lang=js"
export * from "./VuetifyCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5418bb2",
  null
  
)

export default component.exports